import * as React from "react";
import {BulkActions} from "shared/controls/WPTable/WPTable";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import './Styles.css'
import {ToastService} from "shared/utilities/services/ToastService";
export class WPPagination extends React.Component<WPPaginationProps, WPPaginationState> {
    static defaultProps: Partial<WPPaginationProps> = {};

    constructor(props: WPPaginationProps) {
        super(props);
        this.state = {
            PageIndex:props.PageIndex+1,
            SelectedBulkActions:-1,
            BulkActionIsBusy:false
        };
    }

    componentWillReceiveProps(nextProps: Readonly<WPPaginationProps>, nextContext: any): void {
        if(nextProps.PageIndex+1!=this.state.PageIndex)
            this.setState({PageIndex:nextProps.PageIndex+1});
    }

    public render() {
        let maxPage=this.props.Size>0?Math.ceil(this.props.RowsCount/this.props.Size):0;
        return (
            <div >
                <div className="tablenav-pages" style={{float:"none",textAlign:'right'}}>
                    {this.props.BulkActions.length>0&&
                        <div style={{display:'inline-flex',float:'left'}} >
                            <select style={{padding:0,height:28}} value={this.state.SelectedBulkActions} onChange={e=>this.setState({SelectedBulkActions:e.target.value as any})}>

                                <option value={-1}>Bulk Actions</option>
                                {this.props.BulkActions.map((x,i)=>
                                    <option key={i} value={i}>{x.Title}</option>
                                )}
                            </select>
                            <SpinnerButton SpinnerColor={'#000000'} OnClick={()=>this.BulkActionClick()} IsBusy={this.state.BulkActionIsBusy} Icon={null} disabled={this.props.RowsCount==0}  className={'rednao button action'} style={{marginLeft:5}}>Apply</SpinnerButton>
                        </div>
                    }
                    {this.props.RowsCount>0&&<div>
                        <span className="displaying-num">{this.props.RowsCount} items</span>
                        <span className="pagination-links">
                        <button disabled={this.props.PageIndex==0} onClick={e=>this.PageChanged(0)} className="tablenav-pages-navspan button" aria-hidden="true">«</button>
                        <button disabled={this.props.PageIndex==0} onClick={e=>this.PageChanged(this.props.PageIndex-1)} className="tablenav-pages-navspan button" aria-hidden="true">‹</button>
                        <span className="paging-input">
                            <label htmlFor="current-page-selector" className="screen-reader-text">Current Page</label>
                            <input onKeyPress={e=>e.keyCode==13&&this.OnPageInputChanged()} style={{verticalAlign:'bottom',display:'inline-block',width:50,height:28}} className="current-page" id="current-page-selector" type="text" name="paged" onChange={e=>this.setState({PageIndex:e.target.value as any})} value={this.state.PageIndex} aria-describedby="table-paging"/>
                                <span className="tablenav-paging-text" style={{margin:'0 4px 0 4px'}}>
                                    of <span className="total-pages">{maxPage}</span>
                                </span>
                        </span>
                        <button disabled={this.props.PageIndex+1==maxPage} className="next-page button"   onClick={e=>{e.preventDefault(); this.PageChanged(this.props.PageIndex+1)}}>
                            <span   className="screen-reader-text">Next page</span><span aria-hidden="true">›</span>
                        </button>
                        <button disabled={this.props.PageIndex+1==maxPage} onClick={e=>{e.preventDefault(); this.PageChanged(this.props.Size>0?Math.ceil(this.props.RowsCount/this.props.Size):0)}}
                           className="last-page button" >
                            <span className="screen-reader-text">Last page</span>
                            <span   aria-hidden="true">»</span>
                        </button>
                        </span>
                    </div>}
                </div>
                <br className="clear"/>
            </div>
        )
    }

    private PageChanged(value: number) {
        let maxPage=this.props.Size>0?Math.ceil(this.props.RowsCount/this.props.Size)-1:0;
        if(value>maxPage)
            value=maxPage;
        if(value<0)
            value=0;

        this.props.PageChanged&&this.props.PageChanged(value);
    }

    private OnPageInputChanged() {
        let number=parseInt(this.state.PageIndex.toString());
        if(isNaN(number))
            return;


        this.PageChanged(number)


    }

    private async BulkActionClick() {
        if(this.state.SelectedBulkActions==-1||this.props.BulkActions.length<=this.state.SelectedBulkActions)
        {
            ToastService.SendErrorMessage('Please select an action first');
            return;
        }

        let result:any=this.props.BulkActions[this.state.SelectedBulkActions].CallBack();
        if(result instanceof Promise)
        {
            this.setState({BulkActionIsBusy:true});
            result= await result;
            this.setState({BulkActionIsBusy:false});
        }

        if(result)
            this.setState({SelectedBulkActions:-1});






    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface WPPaginationProps {
    Size:number;
    PageIndex:number;
    RowsCount:number;
    PageChanged:(pageIndex:number)=>void;
    BulkActions:BulkActions[];
}

interface WPPaginationState {
    PageIndex:number;
    SelectedBulkActions:number;
    BulkActionIsBusy:boolean;
}

//#endregion "My Region"